<template>
  <section 
    class="mt-20 mb-40 bg-[#F3F5FB] multimedia-section pt-10 lg:pt-25 bg-right-top bg-no-repeat"
    :class="{
      [`bg-[url(${mask})]`]: true
    }"
  >
    <Container className="lg:flex gap-24">
      <div class="flex-none w-full lg:w-80 mb-8 text-center lg:text-left lg:mb-0">
        <div class="flex h-full items-center">
          <div class="flex flex-wrap justify-center w-full lg:w-auto lg:justify-start lg:flex-col gap-2">
            <div v-for="item in items" :key="item.value" class="w-full lg:w-auto">
              <button 
                class="text-center sm:text-left text-3xl! lg:text-5xl! p-0 cursor-pointer"
                :data-scroll-name="item.value"
                :class="{
                  'text-primary-color': !getPrimaryColor && activeItem.value === item.value,
                  [`text-[${getPrimaryColor}]`]: getPrimaryColor && activeItem.value === item.value,
                  'text-secondary-color hover:text-gray-900!': activeItem.value !== item.value,
                }"
                @click="setActiveItem(item)"
              >
               {{ item.label }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="flex-1 -mb-20">
        <div>
          <component :is="activeItem.component" />
        </div>
      </div>
    </Container>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Container from '../../components/Container';
  import mask from "./mask-group-2.png";

  export default {
    name: 'MultimediaSection',
    props: {
      items: {
        type: Array // [{ value, label, component }]
      },
      itemValue: {
        type: String
      }
    },
    components: {
      Container,
    },
    data () {
      return {
        activeItem: this.items[0],
        mask
      }
    },
    computed: {
      ...mapGetters('tour', ['getPrimaryColor']),
    },
    methods: {
      setActiveItem (item) {
        this.activeItem = item;
      }
    },
    watch: {
      itemValue () {
        const matchedItem = this.items.find(item => item.value === this.itemValue);

        if (matchedItem) {
          this.activeItem = matchedItem; 
        }
      }
    }
  };
</script>

<style>
  .multimedia-section {
    .hmt-video-wrapper {
      margin-bottom: 0;
    }
  }
</style>
